import React, { useEffect } from "react";
import { Table, Switch, Space, Tooltip, Popover, Image } from "antd";
import { ColumnsType } from "antd/es/table";
import { useGoodsModel } from "../materialModel";
import { IMaterialDetail } from "../materialService";
import { momentFormat } from "@/utils/utils";
import useNavModel from "@/model/navModel";
import { getBaseImgLookUrl, tableSize } from "@/utils/constants";
import YhTootip from "@/components/YhTootip";
import { useDictModel } from "../../dict/dictModel";

export function DataTable() {
    const {
        dataSource, selectedRowKeys, pgCfg,
        loadData, setSelectedRowKeys,
        onDisabled
    } = useGoodsModel();
    const { selectedNavId, replaceNav } = useNavModel();
    const { getTreeNodeName } = useDictModel();
    const onLook = (code: string) => {
        let supplierEditKey = "13-2-3";
        replaceNav(
            selectedNavId,
            supplierEditKey,
            { id: code, mode: "look", },
            true
        );
    }
    const parseFileList = (str: any) => {
        if (!str || typeof str !== 'string') {
            return [];
        }
        try {
            const arr = JSON.parse(str);
            return Array.isArray(arr) ? arr : [];
        } catch (err) {
            console.error('文件列表解析失败：', err);
            return [];
        }
    }
    const columns: any = [
        {
            title: '序号',
            fixed: "left",
            width: 60,
            dataIndex: 'branch',
            render: (text: any, record: any, index: any) => `${index + 1}`
        }, {
            title: '商品编码',
            width: 120,
            dataIndex: 'code',
            // render: (text: any, record: any) => <Tooltip placement="topLeft" title={text}><p className="ellipsis click-span" onClick={(e) => {e.stopPropagation(); onLook(record.id)}}>{text}</p></Tooltip>,
            render: (text: any, record: any) => <YhTootip text={text} onClick={(e) => onLook(record.id)} />,
        }, {
            title: '配件名称',
            width: 130,
            dataIndex: 'name',
            render: (text: any) => <YhTootip text={text} style={{ width: 130 }} />,
        },
        //  {
        //     title: '商品类别',
        //     width: 160,
        //     dataIndex: 'typeCategory',
        //     render: (text: any) => <YhTootip text={getTreeNodeName(text)} />,
        // }, 
        {
            title: '适用车型',
            width: 120,
            dataIndex: 'vehicleModel',
            render: (text: any) => <YhTootip text={text} style={{ width: 120 }} />,

        }, {
            title: '商品类型',
            width: 160,
            dataIndex: 'typeName',
        }, {
            title: '上装品牌',
            width: 110,
            dataIndex: 'upperClothBrand',
        }, {
            title: '底盘品牌',
            width: 110,
            dataIndex: 'chassisBrand',
        }, {
            title: '配件品牌',
            width: 160,
            dataIndex: 'brandName',
            render: (text: any) => <YhTootip text={text} style={{ width: 160 }} />,
        }, {
            title: '进货价',
            width: 160,
            dataIndex: 'purchasePrice',
            render: (text: string, record: any) => (record?.materialDetal?.[0]?.purchasePrice) ?? text
        }, {
            title: '零售价',
            width: 120,
            dataIndex: 'retailPrice',
            render: (text: string, record: any) => (record?.materialDetal?.[0].repairPrice) ?? text
        }, {
            title: '创建人',
            width: 120,
            dataIndex: 'createUser',
        }, {
            title: '创建时间',
            width: 140,
            dataIndex: 'createTime',
            render: (text: any) => momentFormat(text)
        }, {
            title: '供应商名称',
            width: 170,
            dataIndex: 'supplierName',
            render: (text: any) => <YhTootip text={text} style={{ width: 170 }} />,
        }, {
            title: '截止时间',
            width: 150,
            dataIndex: 'endTime',
            render: (text: any) => momentFormat(text)
        },
        //  {
        //     title: '所属站点',
        //     width: 160,
        //     dataIndex: 'shopName',
        // }, 
        {
            title: '备注',
            // width: 160,
            dataIndex: 'note',
        }, {
            title: '配件图片',
            width: 130,
            align: 'center',
            fixed: "right",
            dataIndex: 'fileMsg',
            render: (text: string, record: any) => {
                let imageList = parseFileList(record.fileMsg)

                // 无图片时显示提示
                if (imageList.length === 0) {
                    return <span style={{ color: '#999' }}>无配件图片</span>;
                }

                // 生成完整图片URL
                const imageUrls = imageList.map(item => getBaseImgLookUrl(item.uid));

                // 展示第一张图片作为缩略图，点击显示所有图片
                return (
                    <Image.PreviewGroup
                    >
                        <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap', }}>
                            {imageUrls.map((url, index) => (
                                <Image
                                    key={index}
                                    src={url}
                                    alt={`配件图片${index + 1}`}
                                    style={{ width: 30, height: 20, objectFit: 'cover' }}
                                    preview // 支持点击放大预览
                                />
                            ))}
                        </div>
                    </Image.PreviewGroup>
                );
            },
        }, , {
            title: '操作',
            width: 160,
            dataIndex: 'enable',
            fixed: "right",
            render: (text: any, record: any) => (
                <Space size="middle">
                    <Switch checked={record.enable === 1} onChange={(checked) => {
                        onDisabled(record.id as string, checked);
                    }} />
                </Space>
            ),
        }
    ];
    //点击行选高亮
    const onRow = (id: string) => {
        let findIndex = selectedRowKeys.indexOf(id);
        let newSelectedRowKeys = [...selectedRowKeys];
        if (findIndex === -1) {
            newSelectedRowKeys.push(id);
            setSelectedRowKeys(newSelectedRowKeys);
        } else {
            newSelectedRowKeys.splice(findIndex, 1);
            setSelectedRowKeys(newSelectedRowKeys);
        }
    };

    useEffect(() => {
        loadData()
    }, [])

    return (
        <Table
            bordered
            rowKey={record => record.id}
            size={tableSize}
            rowSelection={{
                selectedRowKeys: selectedRowKeys, //记录选中
                onChange: (selectedRowKeys: React.Key[], selectedRows: IMaterialDetail[]) => {
                    setSelectedRowKeys(selectedRowKeys as string[]);
                }
            }}
            columns={columns}
            dataSource={dataSource}
            pagination={{
                showSizeChanger: true,
                ...pgCfg,
                defaultPageSize: 25,
                pageSizeOptions: ['15', '25', '50', '100', '200', '500'],
                position: ["bottomRight"],
                showTotal: () => `共${pgCfg.total}条`,
                onChange: (pageNum, pageSize) => {
                    loadData({ pageNum, pageSize })
                }
            }}
            onRow={record => ({
                onClick: () => onRow(record.id),
                onContextMenu: (e) => {
                    e.preventDefault();
                    setSelectedRowKeys([record.id as string]);
                }
            })}
            scroll={{ x: 'max-content', y: "calc(100vh - 360px)" }}
        />
    )
}
